/**
 * Shared styles for health information scroll content (full screen + bottom sheets).
 * Used by: `HealthInformationScrollBody`, `HealthInformationSourcesScreen` (v1/v3 re-exports).
 */
import { StyleSheet } from 'react-native';

import { appTheme } from '../../shared/theme';
import type { ThemeColors } from '../../shared/theme/store';

export function createHealthInformationSourcesStyles(c: ThemeColors) {
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: c.background,
    },
    scroll: {
      flex: 1,
    },
    scrollContent: {
      paddingHorizontal: appTheme.spacing.lg,
      paddingBottom: appTheme.spacing.xl * 2,
    },
    prominentDisclaimerBanner: {
      marginTop: appTheme.spacing.md,
      marginBottom: appTheme.spacing.lg,
      padding: appTheme.spacing.md,
      borderRadius: 22,
      backgroundColor: c.primaryUltra ?? `${c.primary}14`,
    },
    prominentDisclaimerText: {
      ...appTheme.typography.body,
      fontSize: 15,
      fontWeight: '600',
      lineHeight: 22,
      color: c.text,
    },
    introTitle: {
      ...appTheme.typography.h3,
      color: c.text,
      marginTop: appTheme.spacing.md,
      marginBottom: appTheme.spacing.sm,
    },
    paragraph: {
      ...appTheme.typography.body,
      fontSize: 15,
      lineHeight: 24,
      color: c.textSecondary,
      marginBottom: appTheme.spacing.md,
    },
    boundaryBox: {
      padding: appTheme.spacing.md,
      marginBottom: appTheme.spacing.md,
      borderRadius: 22,
      backgroundColor: c.surface,
    },
    sectionHeading: {
      ...appTheme.typography.bodySmall,
      fontWeight: '700',
      color: c.text,
      textTransform: 'uppercase',
      letterSpacing: 0.6,
      marginTop: appTheme.spacing.lg,
      marginBottom: appTheme.spacing.sm,
    },
    linkCard: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: appTheme.spacing.md,
      paddingHorizontal: appTheme.spacing.md,
      marginBottom: appTheme.spacing.sm,
      backgroundColor: c.surface,
      borderRadius: 22,
    },
    linkCardLeft: {
      flex: 1,
      minWidth: 0,
      paddingEnd: appTheme.spacing.md,
    },
    linkTitle: {
      ...appTheme.typography.body,
      fontWeight: '600',
      color: c.text,
    },
    linkSubtitle: {
      ...appTheme.typography.bodySmall,
      color: c.textSecondary,
      marginTop: 4,
    },
    urlMono: {
      ...appTheme.typography.caption,
      color: c.primary,
      marginTop: 6,
    },
    disclaimerBox: {
      marginTop: appTheme.spacing.xl,
      padding: appTheme.spacing.md,
      borderRadius: appTheme.borderRadius.md,
      backgroundColor: c.surfaceLight,
      borderWidth: 1,
      borderColor: c.border,
    },
    disclaimerText: {
      ...appTheme.typography.bodySmall,
      color: c.textSecondary,
      lineHeight: 20,
    },
    linkChevron: {
      ...appTheme.typography.body,
      fontWeight: '700',
      color: c.primary,
      fontSize: 18,
    },
  });
}
